import type { FC } from "react";
import { memo } from "react";

import { defaultToTrue } from "@Components/Modules/Helpers";
import * as stylex from "@stylexjs/stylex";

import type { IMapMarker, IMapMarkerInfo } from "./MapMarker";
import { address, logo, name, offersLink } from "./MapMarker";

import * as cssMapMarker from "./MapMarker.module.css";

export interface IShoppingMallMapMarkerInfo extends IMapMarkerInfo {
    openHoursText: string;
}

export interface IShoppingMallMapMarker extends IMapMarker {
    id: string;
    info: IShoppingMallMapMarkerInfo;
}

export const ShoppingMallMapMarkerInfo: FC<IShoppingMallMapMarkerInfo> = memo(
    (props) => (
        <div className={cssMapMarker.mapMarkerInfoComponent}>
            {logo(props)}
            {name(props)}
            {address(props)}
            {props.openHoursText && (
                <div
                    {...stylex.props(styles.openHours)}
                    dangerouslySetInnerHTML={{ __html: props.openHoursText }}
                />
            )}
            {offersLink(props)}
        </div>
    ),
    defaultToTrue,
);

const styles = stylex.create({
    openHours: {
        paddingTop: "20px",
    },
});
